import { Button, DialogContentText, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import SimpleDialog from './SimpleDialog';
import type { SimpleDialogProps } from './SimpleDialog';
import type { ButtonProps, TextFieldProps } from '@mui/material';
import type { ElementType, FC } from 'react';

interface PromptDialogProps<ButtonComponentType extends ElementType = ElementType>
  extends Omit<SimpleDialogProps, 'content' | 'actions'> {
  onClose: () => void;
  onSave: (value: string) => void;
  textFiledProps?: TextFieldProps;
  defaultValue?: string;
  description?: string;
  saveButtonProps?: Omit<ButtonProps<ButtonComponentType>, 'onClick'>;
  cancelButtonProps?: Omit<ButtonProps<ButtonComponentType>, 'onClick'>;
}

const PromptDialog: FC<PromptDialogProps> = ({
  textFiledProps,
  onClose,
  onSave,
  defaultValue,
  description,
  saveButtonProps,
  cancelButtonProps,
  ...dialogProps
}) => {
  const [value, setValue] = useState<string>(defaultValue ?? '');

  useEffect(() => {
    if (dialogProps.open) setValue(defaultValue ?? '');
  }, [dialogProps.open, defaultValue]);

  return (
    <SimpleDialog
      {...dialogProps}
      onClose={onClose}
      actions={
        <>
          <Button
            {...saveButtonProps}
            onClick={() => {
              onSave(value);
            }}>
            Сохранить
          </Button>
          <Button {...cancelButtonProps} onClick={onClose}>
            Закрыть
          </Button>
        </>
      }
      content={
        <>
          <DialogContentText>{description}</DialogContentText>
          <TextField
            inputProps={{ autoComplete: 'off' }}
            autoFocus
            margin='dense'
            id='prompt'
            type='text'
            value={value}
            onChange={(event) => {
              setValue(event.target.value);
            }}
            fullWidth
            {...textFiledProps}
          />
        </>
      }
    />
  );
};

export default PromptDialog;
